/** Тип штрихкода. */
export enum BarcodeType {
    EAN13 = "EAN13",
    EAN8 = "EAN8",
    UPCA = "UPCA",
    CODE128 = "CODE128",
    QRCODE = "QRCODE",
}
